import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Image from 'gatsby-image';
import _ from 'lodash';

import Timeline from '../../animations/timeline';
import Avatar from '../avatar';
import Link from '../link';

import * as HeaderStyles from './header';
import * as PortfolioStyles from './portfolio';
import * as LayoutStyles from '../layout';

export default function Content() {
    const { dataJson: data, allImageSharp, allFile } = useStaticQuery(graphql`
        query dataJsonQuery {
            dataJson {
                name
                caption
                description
                links {
                    src
                    url
                    altText
                }
            }
            allImageSharp {
                nodes {
                    fluid(maxWidth: 300) {
                        ...GatsbyImageSharpFluid
                        originalName
                    }
                }
            }
            allFile(filter: {extension: {regex: "/(jpg)/"}, relativePath: {regex: "/portfolio\//"}}) {
                edges {
                    node {
                        id
                        name
                        relativePath
                        childImageSharp {
                            fluid(maxWidth: 300) {
                                ...GatsbyImageSharpFluid
                                originalName
                            }
                        }
                    }
                }
            }
        }
    `);

    const portfolio = _.groupBy(allFile.edges, ({ node }) => _.split(node.relativePath, '/', 3)[1]);
    const portfolioCategories = _.keys(portfolio).sort();

    /* TODO: MASONRY
        1. calculate columns width (2 or 3)
        2. for each item, set absolute position (with fadein animation)
        3. calculate gallery height and set it
    */

    // TODO Split galleries into sections with headings
    // order: weddings, portraits, bts, music

    return (
        <div>
            <Timeline>{({ animations }) => (
                <>
                    <HeaderStyles.Header key="header">
                        <Avatar
                            key="avatar"
                            animation={animations.avatar}
                            imageAnimation={animations.image}
                        />
                        <HeaderStyles.Name animation={animations.name} >{data.name}</HeaderStyles.Name>
                        <HeaderStyles.Caption animation={animations.caption} >{data.caption}</HeaderStyles.Caption>
                        {/* <HeaderStyles.Description animation={ animations.description }>
                            { data.description }
                        </HeaderStyles.Description> */}
                        <HeaderStyles.SocialLinks animation={animations.links}>{
                            data.links.map((link) => (
                                <Link key={link.id} href={link.url}>
                                    <HeaderStyles.Logo
                                        as={Image}
                                        fluid={allImageSharp.nodes.find(node => link.src === node.fluid.originalName).fluid}
                                        alt={link.altText}
                                    />
                                </Link>
                            ))
                        }</HeaderStyles.SocialLinks>
                    </HeaderStyles.Header>
                    <PortfolioStyles.Container key="portfolio" animation={animations.portfolio}>
                        {/* <PortfolioStyles.Header>
                            portfolio header
                        </PortfolioStyles.Header> */}
                        {
                            portfolioCategories.map(category => (
                                <>
                                    <PortfolioStyles.ImageGallery key={category}>{
                                        portfolio[category].map(({ node }) => (
                                            <PortfolioStyles.ImageGalleryItem key={node.name}>
                                                <PortfolioStyles.ImageGalleryItemImage
                                                    as={Image}
                                                    fluid={node.childImageSharp.fluid}
                                                />
                                            </PortfolioStyles.ImageGalleryItem>
                                        ))
                                    }
                                    </PortfolioStyles.ImageGallery>
                                    <PortfolioStyles.ImageGallerySeparator />
                                </>
                            ))
                        }
                    </PortfolioStyles.Container>
                </>
            )}
            </Timeline>
        </div>
    );
}
